import { Signature, SignedTransaction } from '@near-js/transactions';
import { getTransactionLastResult } from '@near-js/utils';
import { sha256 } from '@noble/hashes/sha256';
import { getNonce } from '../view';
const DEFAULT_FINALITY = { finality: 'final' };
/**
 * Sign a transaction, returning the signed transaction and encoded hash
 * @param transaction Transaction instance
 * @param signer MessageSigner
 */
export async function signTransaction({ transaction, deps: { signer } }) {
    const encodedTx = transaction.encode();
    const signedTransaction = new SignedTransaction({
        transaction,
        signature: new Signature({
            keyType: transaction.publicKey.keyType,
            data: await signer.signMessage(encodedTx),
        }),
    });
    return {
        encodedTransactionHash: new Uint8Array(sha256(encodedTx)),
        signedTransaction,
    };
}
/**
 * Sign a transaction and publish to RPC
 * @param transaction Transaction instance to sign and publish
 * @param deps sign-and-send dependencies
 */
export async function signAndSendTransaction({ transaction, deps: { rpcProvider, signer } }) {
    const { signedTransaction } = await signTransaction({ transaction, deps: { signer } });
    const outcome = await rpcProvider.sendTransaction(signedTransaction);
    return {
        outcome,
        result: getTransactionLastResult(outcome),
    };
}
/**
 * Get the current nonce for an access key given an account and MessageSigner instance
 * @param account owner of the access key
 * @param blockReference block ID/finality
 * @param rpcProvider RPC provider instance
 * @param deps sign-and-send dependencies
 */
export async function getSignerNonce({ account, blockReference = DEFAULT_FINALITY, deps: { rpcProvider, signer } }) {
    return getNonce({
        account,
        publicKey: (await signer.getPublicKey()).toString(),
        blockReference,
        deps: { rpcProvider },
    });
}
